import React, { useState } from 'react';
import { galleryImages } from '../mock';
import { X } from 'lucide-react';

const Gallery = () => {
  const [selectedImage, setSelectedImage] = useState(null);
  const [filter, setFilter] = useState('all');

  const filteredImages = filter === 'all' 
    ? galleryImages 
    : galleryImages.filter(img => img.category === filter);

  return (
    <section id="gallery" className="py-20 bg-slate-50">
      <div className="container mx-auto px-4">
        {/* Section Header */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-slate-900 mb-4">
            Our Work
          </h2>
          <p className="text-xl text-slate-600 max-w-2xl mx-auto mb-8">
            Browse through our portfolio of completed projects and see the quality of our craftsmanship
          </p>

          {/* Filter Buttons */}
          <div className="flex flex-wrap justify-center gap-3">
            <button
              onClick={() => setFilter('all')}
              className={`px-6 py-2 rounded-full font-medium transition-all ${
                filter === 'all'
                  ? 'bg-amber-500 text-white shadow-lg'
                  : 'bg-white text-slate-700 hover:bg-amber-100'
              }`}
            >
              All Projects
            </button>
            <button
              onClick={() => setFilter('kitchen')}
              className={`px-6 py-2 rounded-full font-medium transition-all ${
                filter === 'kitchen'
                  ? 'bg-amber-500 text-white shadow-lg'
                  : 'bg-white text-slate-700 hover:bg-amber-100'
              }`}
            >
              Kitchens
            </button>
            <button
              onClick={() => setFilter('bathroom')}
              className={`px-6 py-2 rounded-full font-medium transition-all ${
                filter === 'bathroom'
                  ? 'bg-amber-500 text-white shadow-lg'
                  : 'bg-white text-slate-700 hover:bg-amber-100'
              }`}
            >
              Bathrooms
            </button>
            <button
              onClick={() => setFilter('bedroom')}
              className={`px-6 py-2 rounded-full font-medium transition-all ${
                filter === 'bedroom'
                  ? 'bg-amber-500 text-white shadow-lg'
                  : 'bg-white text-slate-700 hover:bg-amber-100'
              }`}
            >
              Bedrooms
            </button>
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) => (
            <div
              key={image.id}
              className="group relative overflow-hidden rounded-xl cursor-pointer shadow-md hover:shadow-2xl transition-all duration-300"
              onClick={() => setSelectedImage(image)}
            >
              <img
                src={image.url}
                alt={image.title}
                className="w-full h-72 object-cover group-hover:scale-110 transition-transform duration-500"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-slate-900/80 via-slate-900/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-white text-xl font-semibold">{image.title}</h3>
                  <span className="inline-block mt-2 px-3 py-1 bg-amber-500 text-white text-sm rounded-full capitalize">
                    {image.category}
                  </span>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Lightbox Modal */}
        {selectedImage && (
          <div 
            className="fixed inset-0 bg-black/90 z-50 flex items-center justify-center p-4"
            onClick={() => setSelectedImage(null)}
          >
            <button
              className="absolute top-4 right-4 text-white hover:text-amber-500 transition-colors"
              onClick={() => setSelectedImage(null)}
            >
              <X size={32} />
            </button>
            <img
              src={selectedImage.url}
              alt={selectedImage.title}
              className="max-w-full max-h-[90vh] object-contain rounded-lg"
              onClick={(e) => e.stopPropagation()}
            />
          </div>
        )}
      </div>
    </section>
  );
};

export default Gallery;